import React, { useContext, useMemo, useState } from "react";
import AttributeInputField from "components/attributes/compare-table/attribute-input-field";
import { findField } from "components/attributes/compare-table/field-builder";
import { TaskContext } from "contexts/task";

export const QaOverride = ({ attr, qaAttributes, readOnlyOverride, onCancel, onRefresh }) => {
    const { task } = useContext(TaskContext);
    const [data, setData] = useState(qaAttributes);
    const component = useMemo(
        () => findField(attr.componentType, task.isCompleted || (attr.readOnly && !readOnlyOverride)),
        [attr.componentType, attr.readOnly, readOnlyOverride, task.isCompleted],
    );

    const updatePanelState = (name, value) => {
        var newData = {
            ...data,
            [name.uuid]: value,
        };
        setData(newData);
    };

    return (
        <div>
            <AttributeInputField
                key={`AIF_${attr.uuid}_qa`}
                Field={component}
                isReadOnly={attr.readOnly && !readOnlyOverride}
                upc={task.upc}
                attribute={attr}
                updateOverride={updatePanelState}
                isCompleted={task.isCompleted}
                photoWipKey={task.context.photographyWipKey}
                codingWipKey={task.context.codingWipKey}
            />
            <div className="button-group -right -wrap">
                <button
                    className="button -default -small"
                    onClick={onCancel}
                >
                    Cancel
                </button>
                <button
                    className="button -primary -small"
                    onClick={onRefresh}
                >
                    Close
                </button>
            </div>
        </div>
    );
};
